import axios from '../axios'

/*
 * 权限管理模块
 */

// 保存
export const save = (data) => {
    return axios({
        url: '/sysPrivilege/save',
        method: 'post',
        data
    })
}
// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/sysPrivilege/delete',
        method: 'post',
        data
    })
}
// 列表页查询
export const list = (data) => {
    return axios({
        url: '/sysPrivilege/list',
        method: 'post',
        data
    })
};

// 查看
export const view = (data) => {
  return axios({
    url: '/sysPrivilege/view',
    method: 'post',
    data
  })
};

// 查询角色菜单集合
export const findRoleMenus = (params) => {
    return axios({
        url: '/sysPrivilege/findRoleMenus',
        method: 'post',
        params
    })
};

// 保存角色菜单集合
export const saveRoleMenus = (data) => {
    return axios({
        url: '/sysPrivilege/saveRoleMenus',
        method: 'post',
        data
    })
}

// 权限树导入
export const importPrivilegeTree = (data) => {
  return axios({
    url: '/sysPrivilege/importPrivilegeTree',
    method: 'post',
    data
  })
}

// 用户选择角色
export const selectRoles = (params) => {
  return axios({
    url: '/sysPrivilege/selectRoles',
    method: 'post',
    params
  })
}
// 上移
export const moveUp = (data) => {
  return axios({
    url: '/sysPrivilege/moveUpNode',
    method: 'post',
    data
  })
}
// 下移
export const moveDown = (data) => {
  return axios({
    url: '/sysPrivilege/moveDownNode',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/privilege.js